<template>
  <a-layout>
    <HeaderTop />
    <a-layout>
      
       <HeaderPage indexmenu="RengongYlqRw" />
      <a-layout style="padding: 0px 12px 24px;background: #fff;margin-left: 12px;border-radius: 8px;">
        <a-layout-content> <RengongYlqRwPrintContent msg=""/> </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
// @ is an alias to /src
import HeaderPage from '@/components/HeaderPage.vue'
import HeaderTop from '@/components/HeaderTop.vue'

import RengongYlqRwPrintContent from '@/components/rengongcuiping/RengongYlqRwPrintContent.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderPage,
    HeaderTop,
    RengongYlqRwPrintContent
  },
  data(){
    return {
    }
  }
}
</script>
